import { getDeployment } from './getDeployment';

export const getImagePath = () =>
  getDeployment() === 'production'
    ? 'https://cdn.stage.bio/'
    : 'https://cdn.preview.stage.bio/';
